import { useCallback } from 'react';

import { logoIcon } from '../../assets';
import { setToastInfo, setToastVisible, useAppDispatch, useAppSelector } from '../../state';
import BackButton from '../EditHeader/BackButton';
import Notification from '../EditHeader/Notification';
import { LocalImage } from '../Image';

interface ICardCreationHeaderProps {
  styles: Record<string, string>;
  backUrl?: string;
}

export function CardCreationHeader(props: ICardCreationHeaderProps) {
  const { styles, backUrl } = props;

  const dispatch = useAppDispatch();
  const { isToastVisible, toastStatus } = useAppSelector((state) => state.edit);

  const onClose = useCallback(() => {
    dispatch(setToastVisible(false));
    dispatch(setToastInfo(undefined));
    if (toastStatus === 'success') {
      location.href = '/create';
    }
  }, [dispatch, toastStatus]);

  return (
    <header className={styles.header}>
      <section className={styles.headerSection}>
        <BackButton styles={styles} backUrl={backUrl} />
      </section>

      <div className={styles.logo}>
        <LocalImage src={logoIcon} />
      </div>

      <div className={styles.title}>{'创建星念'}</div>

      {/* 发布状态Toast */}
      <Notification type={toastStatus} styles={styles} onClose={onClose} open={isToastVisible} />
    </header>
  );
}

export default CardCreationHeader;
